import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {withRouter} from 'react-router-dom';

// Alert
import alert from '@drivesally/sally-ui/lib/libs/alert';

// Api
import createAccidentApi from '@drivesally/sally-fn/lib/accident/api/create.api.accident';

// Attributes
import appointmentTimeAttr from '@drivesally/sally-fn/lib/accident/attributes/appointment_time.attribute.accident';
import cameraUnpluggedAttr from '@drivesally/sally-fn/lib/accident/attributes/camera_unplugged.attribute.accident';
import dateTimeOfLossAttr from '@drivesally/sally-fn/lib/accident/attributes/datetime_of_loss.attribute.accident';
import descriptionAttr from '@drivesally/sally-fn/lib/accident/attributes/description.attribute.accident';
import dolCityAttr from '@drivesally/sally-fn/lib/accident/attributes/dol_city.attribute.accident';
import dolLocationAttr from '@drivesally/sally-fn/lib/accident/attributes/dol_location.attribute.accident';
import dolStateAttr from '@drivesally/sally-fn/lib/accident/attributes/dol_state.attribute.accident';
import driverAttr from '@drivesally/sally-fn/lib/accident/attributes/driver.attribute.accident';
import policeCalledStateAttr from '@drivesally/sally-fn/lib/accident/attributes/police_called_state.attribute.accident';
import policeReportTakenStateAttr from '@drivesally/sally-fn/lib/accident/attributes/police_report_taken_state.attribute.accident';
import rentalAttr from '@drivesally/sally-fn/lib/accident/attributes/rental.attribute.accident';
import rideShareSignedInPeriodAttr from '@drivesally/sally-fn/lib/accident/attributes/rideshare_signed_in_period.attribute.accident';
import rideShareSignedInServiceAttr from '@drivesally/sally-fn/lib/accident/attributes/rideshare_signed_in_service.attribute.accident';
import stateAttr from '@drivesally/sally-fn/lib/accident/attributes/state.attribute.accident';
import towRequiredAttr from '@drivesally/sally-fn/lib/accident/attributes/tow_required.attribute.accident';
import vehicleAttr from '@drivesally/sally-fn/lib/accident/attributes/vehicle.attribute.accident';

// Components
import CreateAccidentStep from '../../components/CreateAccidentStep/CreateAccidentStep';

// Dates
import {parseISO} from 'date-fns';

// Error
import parseError from '@drivesally/sally-fw/lib/error/parseError';

// Prep
import createAccidentPrep from '@drivesally/sally-fn/lib/accident/preparation/create.preparation.accident';

// Routes
import accidentRoute from '../../pages/AccidentPage/route';

class CreateAccidentStepContainer extends Component {
  static propTypes = {
    Container: PropTypes.any,
    visible: PropTypes.bool,
    accident: PropTypes.object,
    driver: PropTypes.object,
    rental: PropTypes.object,
    goingBack: PropTypes.bool,
    onShow: PropTypes.func,
    onHide: PropTypes.func,
    onDisabled: PropTypes.func,
    onClose: PropTypes.func,
    onComplete: PropTypes.func,
    onBack: PropTypes.func,

    history: PropTypes.object,
  };

  state = {
    loading: false,

    appointment_time: appointmentTimeAttr(''),
    camera_unplugged: cameraUnpluggedAttr(false),
    datetime_of_loss: dateTimeOfLossAttr(''),
    description: descriptionAttr(''),
    dol_city: dolCityAttr(''),
    dol_location: dolLocationAttr(''),
    dol_state: dolStateAttr(''),
    police_called_state: policeCalledStateAttr(''),
    police_report_taken_state: policeReportTakenStateAttr(''),
    rideshare_signed_in_period: rideShareSignedInPeriodAttr(''),
    rideshare_signed_in_service: rideShareSignedInServiceAttr(''),
    tow_required: towRequiredAttr(false),
  };

  componentDidMount() {
    this.init();
  }

  init = () => {
    const {accident} = this.props;

    this.setState({
      appointment_time: accident?.appointment_time || appointmentTimeAttr(''),
      camera_unplugged:
        accident?.camera_unplugged || cameraUnpluggedAttr(false),
      datetime_of_loss: accident?.datetime_of_loss || dateTimeOfLossAttr(''),
      description: accident?.description || descriptionAttr(''),
      dol_city: accident?.dol_city || dolCityAttr(''),
      dol_location: accident?.dol_location || dolLocationAttr(''),
      dol_state: accident?.dol_state || dolStateAttr(''),
      police_called_state:
        accident?.police_called_state || policeCalledStateAttr(''),
      police_report_taken_state:
        accident?.police_report_taken_state || policeReportTakenStateAttr(''),
      rideshare_signed_in_period:
        accident?.rideshare_signed_in_period || rideShareSignedInPeriodAttr(''),
      rideshare_signed_in_service:
        accident?.rideshare_signed_in_service ||
        rideShareSignedInServiceAttr(''),
      tow_required: accident?.tow_required || towRequiredAttr(false),
    });
  };

  onBack = () => {
    const {onBack} = this.props;
    const {
      loading,
      appointment_time,
      camera_unplugged,
      datetime_of_loss,
      description,
      dol_city,
      dol_location,
      dol_state,
      police_called_state,
      police_report_taken_state,
      rideshare_signed_in_period,
      rideshare_signed_in_service,
      tow_required,
    } = this.state;
    if (loading) return;
    const accident = {
      appointment_time,
      camera_unplugged,
      datetime_of_loss,
      description,
      dol_city,
      dol_location,
      dol_state,
      police_called_state,
      police_report_taken_state,
      rideshare_signed_in_period,
      rideshare_signed_in_service,
      tow_required,
    };
    onBack({accident});
  };

  onChange = (value, key) => {
    if (this.state.loading) return;
    this.setState({[key]: value});
  };

  create = async () => {
    const {driver, rental, onComplete, onDisabled, history} = this.props;
    const {
      loading,
      appointment_time,
      camera_unplugged,
      datetime_of_loss,
      description,
      dol_city,
      dol_location,
      dol_state,
      police_called_state,
      police_report_taken_state,
      rideshare_signed_in_period,
      rideshare_signed_in_service,
      tow_required,
    } = this.state;

    if (loading) return;

    onDisabled(true);
    this.setState({loading: true});

    try {
      const accident = await createAccidentPrep({
        appointment_time,
        camera_unplugged,
        datetime_of_loss,
        description,
        dol_city,
        dol_location,
        dol_state,
        police_called_state,
        police_report_taken_state,
        rideshare_signed_in_period,
        rideshare_signed_in_service,
        tow_required,

        state: stateAttr('pending_4x4'),

        driver: driverAttr(driver.id),
        rental: rentalAttr(rental.id),
        vehicle: vehicleAttr(rental.vehicle.id),
      });
      accident.rideshare_signed_in =
        !!accident.rideshare_signed_in_service &&
        !!accident.rideshare_signed_in_service.trim().length;
      const newAccident = await createAccidentApi(accident);
      alert.success('Accident created');
      onComplete();
      history.push(accidentRoute(newAccident.id));
    } catch (error) {
      const {message} = parseError(error);
      alert.error(message);
      onDisabled(false);
      this.setState({loading: false});
    }
  };

  disabledDates = () => {
    const {rental} = this.props;
    return !rental
      ? []
      : [
          {before: parseISO(rental.start_date)},
          !!rental.end_date && {after: parseISO(rental.end_date)},
        ].filter((date) => !!date);
  };

  render() {
    const {Container, rental, driver} = this.props;
    const {
      loading,
      appointment_time,
      camera_unplugged,
      datetime_of_loss,
      description,
      dol_city,
      dol_location,
      dol_state,
      police_called_state,
      police_report_taken_state,
      rideshare_signed_in_period,
      rideshare_signed_in_service,
      tow_required,
    } = this.state;
    return (
      <CreateAccidentStep
        Container={Container}
        loading={loading}
        branch={rental?.sally_branch || driver?.sally_branch}
        appointment_time={appointment_time}
        camera_unplugged={camera_unplugged}
        datetime_of_loss={datetime_of_loss}
        description={description}
        dol_city={dol_city}
        dol_location={dol_location}
        dol_state={dol_state}
        police_called_state={police_called_state}
        police_report_taken_state={police_report_taken_state}
        rideshare_signed_in_period={rideshare_signed_in_period}
        rideshare_signed_in_service={rideshare_signed_in_service}
        tow_required={tow_required}
        disabledDates={this.disabledDates()}
        onChange={this.onChange}
        onCreate={this.create}
        onBack={this.onBack}
      />
    );
  }
}

export default withRouter(CreateAccidentStepContainer);
